<mat-card>
  <mat-card-content class="form-container">
    @if(!form){

    <div style="width:50%">
      <code>Loading form...</code>
      <progress id="progress" aria-busy="true" style="height:35px;width:100%;"></progress>
    </div>
    
    }
    @else{
    <!-- sidenav -->
    <section aria-label="Form Summary" class="form-sidenav hide-on-print">
      <mat-card appearance="outlined">
        <mat-card-header>
          <h1>{{form.displayName}}</h1>
        </mat-card-header>
        <mat-card-content>
          <dl>
            <dt><i>{{ 'global.created-by' | translate }}:</i></dt>
            <dd><cite><b>{{form.createdBy}}</b></cite></dd>
            <dt><i>{{ 'global.created-at' | translate }}:</i></dt>
            <dd><cite><b>{{form.createdAt | date:'MMM dd, yyyy hh:mm a'}}</b></cite></dd>
            <dt></dt>
            <dt><i>{{ 'global.updated-by' | translate }}:</i></dt>
            <dd><cite><b>{{form.updatedBy}}</b></cite></dd>
            <dt><i>{{ 'global.updated-at' | translate }}:</i></dt>
            <dd><cite><b>{{form.updatedAt | date:'MMM dd, yyyy hh:mm a'}}</b></cite></dd>
            @if(form.mode === 2){
            <dt><i>{{ 'global.status' | translate}}:</i></dt>
            <dd><cite><b>{{ 'global.status-archived' | translate }}</b></cite></dd>
            }
            <dt>
              &nbsp;
            </dt>
            <dt><i>{{ 'global.assigned-to' | translate }}:</i></dt>
            <dd><cite><b>{{form.assignTo}}</b></cite></dd>
          </dl>
        </mat-card-content>
        <mat-card-actions>
          <button matButton="filled" (click)="print()">{{ 'buttons.print' | translate }}</button>
          <button matButton="tonal" (click)="cancel()">{{ 'buttons.cancel' | translate }}</button>
          <button matButton="filled" [disabled]="!ready()" (click)="save()">{{ 'buttons.save' | translate }}</button>
        </mat-card-actions>
      </mat-card>
    </section>

    <!-- form -->
    <section aria-label="Form" class="form-main">
      <mat-card appearance="outlined">

        <mat-card-content>
          @if(formGroup){
          <form [formGroup]="formGroup" class="form-fields">
            @for(field of form.fields;track field){
            <app-dynamic-field [field]="field" [control]="getFormControl(field)"></app-dynamic-field>
            }
          </form>
          }
          @else{
          <code>...Loading</code>
          }
        </mat-card-content>

      </mat-card>
    </section>

    }
  </mat-card-content>

</mat-card>





